type Props = {
  title: string;
  description: string;
};

export default function GoodsAndWarehouseTooltip({ title, description }: Props) {
  return (
    <div className="w-max max-w-[13.75rem] p-3.5 rounded-2xl">
      <div
        className="absolute inset-0 z-0 rounded-2xl"
        style={{
          background: "linear-gradient(180deg, rgba(24,24,24,0.94) 0%, rgba(31,31,31,0.94) 100%)",
          backdropFilter: "blur(2px)",
          WebkitBackdropFilter: "blur(2px)",
        }}
      />
      <div className="relative z-2">
        <p className="mb-1 text-14 font-bold">{title}</p>
        <p className="text-14 font-medium text-white/70">{description}</p>
      </div>
    </div>
  );
}
